import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

/**
 * This interceptor will add withCredentials = true for all requests.
 */
@Injectable()
export class AuthRequestInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (
        req.url.indexOf("loginconfirm") > 0 ||
        req.url.indexOf("resendconfirmationcode") > 0 ||
        req.url.indexOf("logout") > 0 ||
        req.url.indexOf("modify") > 0 ||
        req.url.indexOf("status") > 0
      ) {
        const authReq = req.clone({
          withCredentials: true
        });
        return next.handle(authReq);
      } else {
        return next.handle(req);
      }
    }
}
